import React, { useState, useEffect } from 'react';
import { NavLink, FormGroup, Label, Input, Button, Spinner } from 'reactstrap';
import { useMutation } from '@apollo/react-hooks';
import { FACTORY_UNREGISTER_BOXES } from '../../mutation/mutation';

export default () => {
  const [boxes, setBoxes] = useState('');
  const [loading, setLoading] = useState(false);
  const [unregisterBoxesMutation, { loading: resetBoxesMutationLoading }] = useMutation(FACTORY_UNREGISTER_BOXES);

  useEffect(() => {
    setLoading(resetBoxesMutationLoading);
  }, [resetBoxesMutationLoading]);

  const deleteBoxes = async () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm(`Are you sure that you want to delete all these boxes from the database ? This action is IRREVERSIBLE`)) {
      const boxesMAC = boxes.split('\n');
      const { data: { savFactoryUnregisterBoxes } } = await unregisterBoxesMutation({ variables: { boxesMAC } });
      if (savFactoryUnregisterBoxes) {
        setBoxes('');
      }
    }
  };

  return (
    <div
      style={{
        justifyContent: 'center', alignItems: 'center', display: 'flex',
        width: 1000, flexDirection: 'column',
      }}
    >
      {loading && <Spinner color="primary" />}
      <FormGroup style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Label for="macAddressInput"><b>Mac addresses to unregister (one per row) :</b></Label>
        <Input
          value={boxes}
          onChange={(e) => setBoxes(e.target.value)}
          type="textarea"
          id="macAddressInput"
          placeholder="ABABABABABAB"
          rows={10}
        />
        <Button disabled={boxes === ''} color="primary" onClick={deleteBoxes} style={{ marginTop: 30 }}>
              Unregister boxes
        </Button>
      </FormGroup>
      <NavLink style={{ marginTop: 60 }} href="/">Go back</NavLink>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/factory/FactoryBoxUnregisterPage.js